import Context from 'skypager-registry/lib/context'
import Helper from '../helper'

export class DataSource extends Helper {
  static isCacheable = true

  static cacheable(setting = true) {
    return this.isCacheable = !!setting
  }

  static createRegistry = (options = {}) => new Context('dataSources', {
    context: require.context('../data-sources', false, /.js$/),
    ...options,
    sourceModule: {
      id: (module && module.id) || __filename,
      filename: __filename, dirname: __dirname,
      ...options.sourceModule || {},
    }
  })

  static attach(project, options = {}) {
    return Helper.attach(project, DataSource, {
      registryProp: 'dataSources',
      lookupProp: 'dataSource',
      registry: options.registry || DataSource.createRegistry(),
      ...options,
    })
  }

  get source() {
    const source = this.provider.default ? this.provider.default : this.provider

    return typeof source === 'function'
      ? (options = {}) => source({...this.options, ...options}, this.context)
      : () => source
  }

  load(options = {}) {
    return Promise.resolve(this.source(options))
  }
}

export default DataSource



// WEBPACK FOOTER //
// ./src/helpers/data-source.js